<template>
  <div class="content">
    <div class="position">
      <p>人事总监</p>
    </div>
    <div class="statement">
      <p class="request">岗位职责：</p>
      <p class="desc">1、在公司经营战略指导下，全面计划、安排、管理市场部工作。
2、制定年度营销策略、营销计划及预算工作。
3、根据目标市场，竞争态势，客户需求等调查，及时掌握市场信息。
4、负责公司品牌推广及品牌运作，定期组织市场公关、广告宣传、促销等活动。
5、撰写市场分析、创意新的盈利模式，策划网站运营，业务拓展和产品销售的综合推广措施；
6、根据公司经营方针和部门业务需要，合理设置部门组织结构和岗位，优化业务流程，提高部门工作效率，完成总经理下达的工作任务。
7、分析总结竞争对手，行业信息，公司产品信息等调研信息，确定调研结果，为公司的总体战略制定提供相关依据；
8、对市场部工作进行指导、监督，协调部门与其他部门的合作关系。
9、项目信息系统框架的规划和设计，制定系统规划方案、可执行方案及预算。
10、领导安排的其他事宜。</p>
    </div>
    <div class="statement second">
      <div>
        <p class="request">任职资格：</p>
        <p class="desc">1、本科以上学历，电子商务、信息管理、工商管理、市场营销等相关专业。
2、5年以上相关工作经验，3年团队管理经验，熟悉互联网、电子商务市场动态。
3、熟知网络营销和线下资源紧密结合，五年以上企业管理经验。
4、有较强的执行力，能带领团队完成年度销售任务。
5、具有敏锐的商业和市场意识，分析问题及解决问题能力强，具有优秀的资源整合能力和业务推进能力
6、拥有良好的市场策划管理能力和团队协调工作能力，有组织实施的执行能力，有整合资源、创新经营的思想；
7、擅长撰写各类策划方案，具有优秀的管理能力、逻辑分析能力，富有激情与创意；
8、具有激励、沟通、协调、团队领导能力，责任心、事业心强，敢于承担责任。</p>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'homeJoinContent'
  }
</script>

<style scoped>

  div.content {
    margin: 2%;
    color: rgb(73, 73, 73);
  }

  div.position {
    font-family: PingFangSC-Semibold, "PingFang SC Semibold", "PingFang SC";
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    text-align: left;
  }

  .statement {
    margin: 0;
    padding-bottom: 2%;
    padding-top: 2%;
  }

  p.request {
    font-size: 16px;
  }

  p.desc {
    font-size: 14px;
    line-height: 35px;
    padding-top: 2%;
  }

  p {
    text-align: left;
    white-space: pre-line;
    padding: 0;
    margin: 0;
  }

  .second {
    border-top: dashed;
    border-width: 2px;
    border-color: rgb(226,226,226);
  }

</style>



// WEBPACK FOOTER //
// HomeJoinPersonnel.vue?363e5d98